import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { KeyGenerator } from '../../handlers/key-generator';
import { AngularGridInstance, GridOption } from 'angular-slickgrid';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-normal-slickgrid-table',
  templateUrl: './normal-slickgrid-table.component.html',
  styleUrls: ['./normal-slickgrid-table.component.scss'],
})
export class NormalSlickgridTableComponent implements OnInit, OnDestroy {
  /* Input & Output Decorators Initialization */
  @Input() set columnDefinitions(value: any[]) {
    this._columnDefinitions = value;
  }
  @Input() set dataSet(value: any[]) {
    this._dataSet = value;
  }
  @Input() set frozenColumnCount(value: number) {
    this._frozenColumnCount = value;
    if (this.grid) {
      this.grid.setOptions({
        frozenColumn: value,
      });
    }
  }
  @Input() showTotal: boolean = false;
  @Input() tableName: string;
  @Input() additionalData = {};

  /* Class Member Initialization */
  gridId = KeyGenerator.generate(5);
  gridOptions: GridOption = {};
  angularGrid: AngularGridInstance;
  dataView: any;
  grid: any;
  gridDataViewObj: any;
  private _columnDefinitions: any[];
  get columnDefinitions(): any[] {
    return this._columnDefinitions;
  }
  private _dataSet: any[];
  get dataSet(): any[] {
    return this._dataSet;
  }
  private _frozenColumnCount: number;
  get frozenColumnCount(): number {
    return this._frozenColumnCount;
  }
  private subs = new Subscription();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      if ((changes['columnDefinitions']?.currentValue && this.grid && this.showTotal) || (changes['dataSet']?.currentValue && this.grid && this.showTotal)) {
        this.updateAllTotals();
      }
    }, 10);
  }

  ngOnInit(): void {
    // console.log('Column Definitions: ', this.columnDefinitions);

    /* Initialization of GridOptions Object */
    this.gridOptions = {
      enableAutoResize: true,
      autoResize: {
        calculateAvailableSizeBy: 'container',
      },
      enableAutoSizeColumns: true,
      enableSorting: true,
      enableGridMenu: false,
      enableHeaderMenu: false,
      enableContextMenu: false,
      enableHeaderButton: true,
      alwaysShowVerticalScroll: false,
      enableColumnReorder: false,
      createFooterRow: this.showTotal,
      showFooterRow: this.showTotal,
      createPreHeaderPanel: false,
      showPreHeaderPanel: false,
      rowHeight: 45,
      footerRowHeight: 45,
      forceFitColumns: true,
      enableColumnPicker: false,
      enableCellNavigation: true,
      enableRowSelection: false,
      editable: true,
      frozenColumn: this.frozenColumnCount,
      autoHeight: false, // Set full height of the grid without any scrolling,
    };
  }

  ngOnDestroy(): void {
    this.angularGrid.destroy();
    this.subs.unsubscribe();
  }

  angularGridReady(event: Event): void {
    const customEvent = event as CustomEvent<AngularGridInstance>;
    this.angularGrid = customEvent.detail;
    this.grid = customEvent.detail.slickGrid;
    this.gridDataViewObj = customEvent.detail.dataView;

    /* To calculate Total when Grid is ready i.e., when grid instance available */
    setTimeout(() => {
      if (this.grid && this.showTotal) {
        this.updateAllTotals();
      }
    }, 10);
  }

  refreshGrid(): void {
    this.grid.invalidate();
    this.gridDataViewObj.refresh();
  }

  updateAllTotals(): void {
    let firstColumnId = this.grid.getColumns()[0].id;
    let columnElement = this.grid.getFooterRowColumn(firstColumnId);
    columnElement.textContent = `Total`;
    let columnIdx = this.grid.getColumns().length;
    while (columnIdx--) {
      if (this.grid.getColumns()[columnIdx].doTotal) {
        this.updateTotal(columnIdx);
      }
    }
  }

  updateTotal(columnIdx): void {
    let columnId = this.grid.getColumns()[columnIdx].id;
    let total = 0;
    let i = this.dataSet.length;
    while (i--) {
      total += parseFloat(this.dataSet[i][columnId]) || 0;
    }
    let columnElement = this.grid.getFooterRowColumn(columnId);
    if (
      this.tableName === 'diagnostics_simulations' &&
      this.additionalData &&
      !(
        this.additionalData['selectedSimuCat'] === 'c_to_d' ||
        this.additionalData['selectedSimuCat'] === 'c_to_d_throughput' ||
        this.additionalData['selectedSimuCat'] === 'c_to_d_space'
      )
    ) {
      const divider = this.additionalData['selectedSimuCat'] === 'space' ? 1000 : 1000000;
      const calculatedTotal = parseFloat((total / divider).toFixed(1));
      const newtotal = new Intl.NumberFormat().format(calculatedTotal);
      columnElement.textContent = `${newtotal}`;
      columnElement.setAttribute('title', `${newtotal}`);
      return;
    } else if (
      this.tableName === 'diagnostics_simulations' &&
      this.additionalData &&
      (this.additionalData['selectedSimuCat'] === 'c_to_d' ||
        this.additionalData['selectedSimuCat'] === 'c_to_d_throughput' ||
        this.additionalData['selectedSimuCat'] === 'c_to_d_space')
    ) {
      columnElement.textContent = `--`;
      return;
    }
    columnElement.textContent = `${total !== 0 ? total.toFixed(2) : total}`;
    columnElement.setAttribute('title', `${total !== 0 ? total.toFixed(2) : total}`);
  }
}
